import * as React from 'react';

import {
  Box,
  CustomFont,
  Footer,
  GlobalStyles,
  Spinner,
  ThemeProvider,
  ToastProvider,
  getTheme,
  thc,
} from '@flightstats/airframe-react';

const ContentWrapper = thc(Box, {
  flex: '1 1 auto',
  padding: {
    xs: '48px 20px 20px',
    md: '48px 32px 32px',
  },
});

const FooterWrapper = thc(
  Box,
  {},
  {
    width: '100%',
    bottom: 0,
    '@media (min-height: 640px)': {
      position: 'fixed',
      bottom: 0,
    },
  },
);

type Props = {
  header?: React.ReactNode;
  loading?: boolean;
  children: React.ReactNode;
};

export const CiriumWrapper: React.FC<Props> = (props: Props) => (
  <ThemeProvider theme={getTheme(false)}>
    <>
      <GlobalStyles />
      <CustomFont />
      <ToastProvider>
        {props.header}
        {props.loading && <Spinner modal />}
        <ContentWrapper>{props.children}</ContentWrapper>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </ToastProvider>
    </>
  </ThemeProvider>
);